import { useEffect } from "react";
import { useAuth } from "@frontegg/react";
import { checkTenantAndUser } from "../services/nocodbService";

export function useSyncUser() {
  const { isAuthenticated, user } = useAuth();

  useEffect(() => {
    const syncUserWithNoCoDB = async () => {
      if (isAuthenticated && user) {
        try {
          const { id: userId, name, email, tenantId, accessToken } = user;
          const tenantsResponse = await fetch(
            "https://app-6yutcyqk6ant.us.frontegg.com/frontegg/identity/resources/users/v3/me/tenants",
            {
              headers: { Authorization: `Bearer ${accessToken}` },
            }
          );
          const tenantsData = await tenantsResponse.json();
          const companyName = tenantsData?.activeTenant?.name || "Not Found";

          await checkTenantAndUser(
            tenantId,
            userId,
            name || "",
            email,
            companyName
          );
        } catch (error: any) {
          console.error("Error syncing user with NoCoDB:", error);
        }
      }
    };

    syncUserWithNoCoDB();
  }, [isAuthenticated, user]);
}
